{
  "pt_BR": "para-familias",
  "cs_CZ": "pro-rodiny",
  "da_DK": "for-familier",
  "de_DE": "fuer-familien",
  "en_GB": "for-families",
  "es_ES": "para-familias",
  "fi_FI": "perheille",
  "fr_FR": "pour-les-familles",
  "it_IT": "per-famiglie",
  "ja_JP": "kazoku-yo",
  "ko_KR": "gajog-yong",
  "nl_NL": "voor-gezinnen",
  "nb_NO": "for-familier",
  "pl_PL": "dla-rodzin",
  "pt_PT": "para-familias",
  "ru_RU": "dlya-semei",
  "sv_SE": "foer-familjer",
  "tr_TR": "aileler-icin",
  "zh_CN": "jia-ting-yong"
}
